import { Box } from '@mui/material';
import './index.css';
import ZendeskLink from 'components/Common/ZendeskLink';
import PasswordBox from './password';
import { validatePassword } from 'utils/helper';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { changePassword } from 'store/actions/authActions';
import { useDispatch } from 'react-redux';
import Button from 'components/Common/Button';
import { PRIMARY_BUTTON } from 'themes/theme';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorIcon from 'assets/icons/error.svg';

const CreatePassword = () => {
    const [spinner, setSpinner] = useState(false);
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();
    // const emailInfo = useSelector(state => state.authReducer)
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const authCode = searchParams.get("AuthCode");
    const emailid = searchParams.get("emailid");

    const [inValid, setInvalid] = useState({ password: false, confirmPassword: false });
    const [formValue, setForm] = useState({ password: '', confirmPassword: '' });
    const handleSubmit = (e) => {
        e.preventDefault();
        if (formValue.password === formValue.confirmPassword) {
            changePassword(emailid, authCode, formValue.confirmPassword, navigate, dispatch, (val, isError) => {
                setSpinner(val);
                setShowError(isError);
            })
            setInvalid({ ...inValid, confirmPassword: false });
        } else {
            setInvalid({ ...inValid, confirmPassword: 'Password and Confirm Password is not matching' });
        }
    }
    const handleBlur = (e) => {
        const { value, name } = e.target;
        if (!value) {
            setInvalid({ ...inValid, [name]: 'This field is Required' });
        } else if (!validatePassword(value)) {
            setInvalid({ ...inValid, [name]: 'Please match requested format' });
        } else {
            setInvalid({ ...inValid, [name]: false });
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...formValue, [name]: value })
    }
    return (
        <Box padding='30px' height='100%' flexDirection='column' justifyContent='center' alignItems='center' display='flex' color='#25245f'>
           <Box marginTop='auto'>
                </Box>
            <h4 style={{ marginTop: '10%' }} className='authTitle text-center'>
                It's time to create your password</h4>
            <Box onSubmit={handleSubmit} width='330px' className='mt-5' component='form'>
                <Box className="my-3 authForm">
                    <Box className={`${inValid.password ? 'inValid' : ''}`}>
                        <PasswordBox name='password' required onBlur={handleBlur} onChange={handleChange} label='New Password' />
                        <Box className='errorMessage mt-1' fontSize='12px' fontWeight={400} color='#D14343'>{inValid.password}</Box>
                    </Box>
                    <Box fontSize='12px' className='pt-2 mb-4' color='#66668F' fontWeight={400}>
                        Must be at least 8 characters and contain one uppercase letter, one
                        lowercase letter, one number and one special character (e.g., ! # $ %)
                    </Box>
                    <Box className={`${inValid.confirmPassword ? 'inValid' : ''}`} marginTop='40px'>
                        <PasswordBox name='confirmPassword' required onChange={handleChange} onBlur={handleBlur} label='Confirm Password' />
                        <Box className='errorMessage mt-1' fontSize='12px' fontWeight={400} marginBottom='75px' color='#D14343'>{inValid.confirmPassword}</Box>
                    </Box>
                </Box>
                {showError &&
                    <Box paddingX='13px' paddingY='20px' border='1px solid #D14343' sx={{ background: '#FDF6F6' }} borderRadius='8px'
                        className='mt-2' color='#A73636' display='flex' alignItems='baseline' justifyContent='space-between'>
                        <Box display='flex' gap='16px' alignItems='baseline'>
                            <Box><img alt='Error Icon' src={ErrorIcon} /></Box>
                            <Box fontSize='14px'>Something went wrong. Please try after some time.</Box>
                        </Box>
                        <Box sx={{cursor: 'pointer'}} >
                            <FontAwesomeIcon onClick={() => setShowError(false)} fontSize='16px' className='font-weight-bold' icon={faClose} />
                        </Box>
                    </Box>
                }
                <Box className='mt-5' textAlign='center'>
                    <Button type={PRIMARY_BUTTON} loading={spinner} sx={{ width: '250px' }} submit>
                        Submit
                    </Button>
                </Box>             
            </Box>
            <Box marginTop='auto'>
                <ZendeskLink />
                </Box>
        </Box>
    )
};

export default CreatePassword;